import { useState, useCallback } from "react";
import InputFieldV2 from '@/components/InputComponentsV2/InputFieldV2';

const InputWithOTPV2 = ({
                        field,
                        value,
                        onChange,
                        error,
                        disabled,
                        disabledHint,
                        otpState,
                        setOtpState,
                        otpHandlers
                      }) => {
  const [otp, setOtp] = useState("");
  const otpInfo = otpState[field.key] || {};

  const shouldShowOTP = !!value;

  const sendOTP = useCallback(async () => {
    if (!value || otpInfo.sent) return;

    await otpHandlers[field.otp.send](value);

    setOtpState(prev => ({
      ...prev,
      [field.key]: {
        sent: true,
        verified: false
      }
    }));
  }, [value, otpInfo.sent, field, otpHandlers, setOtpState]);

  const verifyOTP = useCallback(async () => {
    if (!otp) return;

    const success = await otpHandlers[field.otp.verify](value, otp);

    if (success) {
      setOtpState(prev => ({
        ...prev,
        [field.key]: {
          ...prev[field.key],
          verified: true
        }
      }));
    }
  }, [otp, value, field, otpHandlers, setOtpState]);

  /* ============================
     DISABLED STATE (FULL LOCK)
     ============================ */
  if (disabled) {
    return (
      <InputFieldV2
        field={field}
        value={value}
        onChange={() => {}}
        error={error}
        disabled
        disabledHint={disabledHint}
      />
    );
  }

  return (
    <div className="flex flex-col">
      {/* MAIN INPUT */}
      <InputFieldV2
        field={field}
        value={value}
        onChange={onChange}
        error={error}
      />

      {/* OTP SECTION */}
      {shouldShowOTP && (
        <div className="px-4 mt-2 flex items-center gap-3">
          {!otpInfo.sent ? (
            <button
              type="button"
              onClick={sendOTP}
              className="text-xs text-blue-600 hover:underline"
            >
              Send OTP
            </button>
          ) : otpInfo.verified ? (
            <span className="text-xs text-green-600 font-medium">
              ✓ Verified
            </span>
          ) : (
            <>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP"
                className="border px-2 py-1 rounded text-sm w-24 outline-none"
              />
              <button
                type="button"
                onClick={verifyOTP}
                className="text-xs text-green-600 hover:underline"
              >
                Verify
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default InputWithOTPV2;
